export default class AIGroupPathDto {

    AIGroupId: number;
    AIGroupPathId: number;
    PathId: number;
    PathName: string;

    constructor(aiGroupId: number, aiGroupPathId: number, pathId: number, pathName: string) {
        this.AIGroupId = aiGroupId;
        this.AIGroupPathId = aiGroupPathId;
        this.PathId = pathId;
        this.PathName = pathName;
    }
}
